import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import { ApiError } from '@/api/types';
import { DocSubset } from '@/api/types/backend-dto-types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

type DocSubsetWithDocCount = DocSubset & { docCount: number };

export const useGetDocSubsets = (caseId: string | null) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<DocSubsetWithDocCount[]>(
    [QueryEntity.DocSubsets, { caseId }],
    async () => {
      const res = await fetch(`${APIBaseChronos}/api/case/${caseId}/doc-subset`, fetchConfigGET);
      if (!res.ok) {
        const error = await res.json();
        throw new ApiError(error.code, error.message);
      }
      return await res.json();
    },
    {
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!caseId,
    },
  );
};
